import { Event } from '../../../types';

export type ExtendedEvent = Event & {
  clips: number[];
  isCreationPaid?: boolean;
  isClipsPaid?: boolean;
};

export const getEvents = () => {
  const events: ExtendedEvent[] = [
    {
      eventId: 'z2h',
      region: 'au',
      name: 'The Heroes Lunch',
      userId: '',
      stage: 'Analysis',
      type: 'videographer',
      hasCustomBanner: true,
      hasCustomLogo: true,
      videoMode: 'portrait',
      organiserName: 'zero2hero',
      startDate: '2025-05-09T00:00:00.000+00:00',
      endDate: '2025-05-09T00:00:00.000+00:00',
      created: '2025-04-29T05:43:12.443+00:00',
      modified: '2025-05-15T16:20:43.071+00:00',
      payment: {
        allowDonations: false,
        paid: true,
        date: '2025-05-09T00:00:00.000+00:00',
        stripeId: '',
        amount: 900,
        type: 'auto',
      },
      clips: [],
    },
    {
      eventId: 'vd',
      region: 'au',
      name: 'Vic & Danil Wedding',
      userId: '',
      stage: 'Upload',
      type: 'videographer',
      hasCustomBanner: true,
      hasCustomLogo: true,
      videoMode: 'portrait',
      organiserName: 'Vic & Danil',
      startDate: '2025-03-23T00:00:00.000+00:00',
      endDate: '2025-03-23T00:00:00.000+00:00',
      created: '2025-03-15T09:08:20.676+00:00',
      modified: '2025-03-18T12:47:26.410+00:00',
      payment: {
        allowDonations: false,
        paid: true,
        date: '2025-03-23T00:00:00.000+00:00',
        stripeId: '',
        amount: 0,
        type: 'auto',
      },
      clips: [],
    },
    {
      eventId: 'ps',
      region: 'au',
      name: 'Powerful Steps International Women’s Day Lunch 2025',
      userId: '',
      stage: 'Generation',
      type: 'videographer',
      hasCustomBanner: true,
      hasCustomLogo: true,
      videoMode: 'portrait',
      organiserName: 'Powerful Steps',
      startDate: '2025-03-07T00:00:00.000+00:00',
      endDate: '2025-03-07T00:00:00.000+00:00',
      created: '2025-02-27T00:22:50.267+00:00',
      modified: '2025-03-13T03:11:47.099+00:00',
      payment: {
        allowDonations: false,
        paid: true,
        date: '2025-03-07T00:00:00.000+00:00',
        stripeId: '',
        amount: 900,
        type: 'auto',
      },
      clips: [4, 1, 2, 5, 3],
    },
    {
      eventId: 'r4e',
      region: 'au',
      name: 'Rally4Ever Breakfast',
      userId: '',
      stage: 'Generation',
      type: 'videographer',
      hasCustomBanner: true,
      hasCustomLogo: true,
      videoMode: 'landscape',
      organiserName: 'Rally4Ever',
      startDate: '2024-10-17T00:00:00.000+00:00',
      endDate: '2024-10-17T00:00:00.000+00:00',
      created: '2024-10-10T02:48:16.678+00:00',
      modified: '2024-10-22T00:16:11.843+00:00',
      clips: [7, 5, 8, 3, 6, 1, 2, 4],
    },
    {
      eventId: 'f1',
      region: 'au',
      name: 'Albert Park Circuit, Melbourne',
      userId: '',
      stage: 'Generation',
      type: 'videographer',
      hasCustomBanner: true,
      hasCustomLogo: true,
      videoMode: 'portrait',
      organiserName: 'Formula 1',
      startDate: '2024-03-21T00:00:00.000+00:00',
      endDate: '2024-03-24T00:00:00.000+00:00',
      created: '2024-03-21T05:06:51.680+00:00',
      modified: '2024-04-09T05:06:38.433+00:00',
      payment: {
        allowDonations: false,
        paid: true,
        date: '2024-03-21T00:00:00.000+00:00',
        stripeId: '',
        amount: 300,
        type: 'auto',
      },
      clips: [1, 2],
      isCreationPaid: false,
      isClipsPaid: true,
    },
  ];

  return events;
};

export const getAssetsFile = (
  file: string,
  eventId?: string,
  folder?: string,
) => {
  const s3Folder = `https://crowdclip-media-assets.s3.ap-southeast-2.amazonaws.com/${folder ?? 'attendee-portal-demo'}/`;

  return s3Folder + (eventId ? `${eventId}-` : '') + file;
};
